import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-grass px-5 py-16 sm:px-8" data-id="element-152" data-mp="1qac7xuu2siv8">
      <div className="mx-auto w-full max-w-2xl rounded-2xl bg-white px-6 py-10 text-center shadow-xl sm:px-10" data-id="element-153" data-mp="1o4ew0bauoq68">
        <div className="flex items-center justify-center gap-3" data-id="element-154" data-mp="222d797tvk6hi">
          <span className="rounded-full bg-grass px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-155" data-mp="1x4l9vyagns5x">
            ✔ Zero risk
          </span>
          <span aria-hidden="true" className="text-4xl" data-id="element-156" data-mp="19coaj6o76slp">
            🛡️
          </span>
        </div>

        <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-157" data-mp="14dtev454t9k6">
          7-Day <span className="text-grass-deep" data-id="element-158" data-mp="1j6die5w71j25">Money Back Guarantee</span>
        </h2>

        <p className="mt-4 text-sm text-neutral-600" data-id="element-159" data-mp="1ebr1jn7ceyao">
          Open everything. Check everything. Use the material.
        </p>

        <p className="mt-6 text-xl font-extrabold leading-snug text-neutral-900 sm:text-2xl" data-id="element-160" data-mp="lpg24fvh33fg">
          If Basketball Ready 360 doesn't completely transform the way you plan and run
          your sessions, <span className="text-grass-deep" data-id="element-161" data-mp="tycq6fqxn7qw">we'll refund every cent.</span>
        </p>

        <p className="mt-5 text-xs font-bold uppercase tracking-[0.18em] text-neutral-600" data-id="element-162" data-mp="ypb97n3b2jxu">
          No questions asked.
        </p>

        <p className="mt-7 inline-block rounded-full border border-grass/40 bg-grass/10 px-5 py-2.5 text-xs font-extrabold uppercase tracking-[0.1em] text-grass-deep" data-id="element-163" data-mp="12r69qpdewtak">
          Refund rate below 1%
        </p>
      </div>
    </section>;
}